import { useQueryClient } from "react-query"
import { TApiTasksFilters } from "../../api-client/tasks-api"
import { isEqual } from "lodash"

export function useInvalidateOtherProjectSections(projectId: string, tasksFilters: TApiTasksFilters) {
  const queryClient = useQueryClient()

  // Invalidate all queries with the same projectId but different filters

  return function() {
    console.warn(`Current tasks filters: ${JSON.stringify(tasksFilters)}`)

    queryClient.invalidateQueries({
      predicate: (query) => {
        const queryKey = query.queryKey

        if (queryKey[0] == 'project-sections') {
          console.warn(`Invalidating ${projectId}`)
          console.warn(`Cache: ${JSON.stringify(queryKey[2])}`)
        }

        return (
          Array.isArray(queryKey) &&
          queryKey[0] === "project-sections" &&
          queryKey[1] === projectId &&
          !isEqual(queryKey[2], tasksFilters) // Use lodash isEqual for deep comparison ignoring key order
        )
      }
    })
  }
}